import React from "react";
import Select from "react-select";

const HotelsSelect = ({ hotelList, selectedHotels, setSelectedHotels }) => {
  // Convert API data to react-select format
  const options = hotelList?.map((hotel) => ({
    value: hotel._id,
    label: hotel.hotelName,
    hotelData: hotel, // keep full object if needed
  }));

  return (
    <Select
      isMulti
      options={options}
      value={selectedHotels}
      onChange={(selected) => setSelectedHotels(selected)}
      placeholder="Select Hotels..."
      closeMenuOnSelect={false}
      classNamePrefix="hotel-select"
    />
  );
};

export default HotelsSelect;
